import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import useScreen from "../../hooks/useScreen";
import useSession from "../../hooks/useSession";
import { Channel } from "../../interfaces/tracking";
import { AppDispatch } from "../../reducers/configureStore";
import { fetchAcceptTerms } from "../../services/selfie";
import { Analytics, EventNames } from "../../utils/tracking";
interface TermsAndConsAlertProps {
  isOpenTdC: boolean;
  onCloseTdC: () => void;
  onDeclineTdC: () => void;
  screen: string;
}

const TermsAndConsAlertDialog = (props: TermsAndConsAlertProps) => {
  const { isOpenTdC, onCloseTdC, onDeclineTdC, screen } = props;
  const cancelRef = useRef(null);
  const { currentUser, isLoggedIn } = useSession();
  const dispatch = useDispatch<AppDispatch>();
  const { isMobile } = useScreen();

  const onClickYes = () => {
    screen === "Hair Analysis"
      ? Analytics.event(Channel.GA, EventNames.ANALYSIS_LEGAL_ACCEPTED, {
          device: isMobile ? "mobile" : "desktop",
          login: isLoggedIn(),
        })
      : Analytics.event(Channel.GA, EventNames.LEGAL_ACCEPTED, {
          device: isMobile ? "mobile" : "desktop",
          option: screen,
          login: isLoggedIn(),
        });
    dispatch(
      fetchAcceptTerms({ gti: currentUser?.gti, atgId: currentUser?.atgId })
    );
    onCloseTdC();
  };

  const onClickNo = () => {
    screen === "Hair Analysis"
      ? Analytics.event(Channel.GA, EventNames.ANALYSIS_LEGAL_DENIED, {
          device: isMobile ? "mobile" : "desktop",
          login: isLoggedIn(),
        })
      : Analytics.event(Channel.GA, EventNames.LEGAL_DENIED, {
          device: isMobile ? "mobile" : "desktop",
          option: screen,
          login: isLoggedIn(),
        });
    onCloseTdC();
    onDeclineTdC();
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onCloseTdC}
      isOpen={isOpenTdC}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <AlertDialogOverlay />
      <AlertDialogContent className="AlertDialogContentTdC">
        <VStack justifyContent={{ base: "center", md: "center" }}>
          <Image
            mt={{ base: "24px", md: "34px" }}
            mb={{ base: "10px", md: "14px" }}
            src={
              process.env.PUBLIC_URL + "/assets/images/Exclamation-triangle.svg"
            }
            width={{ base: "53px", md: "58px" }}
            height={{ base: "53px", md: "58px" }}
          />
          <Text
            fontWeight={{ base: "bold", md: "bold" }}
            fontSize={{ base: "16px", md: "18px" }}
            letterSpacing={{ base: "0.25px", md: "0.36px" }}
            pb="0"
            justifyContent={{ base: "center", md: "center" }}
            textAlign={{ base: "center", md: "center" }}
            color="#000"
          >
            Virtual Beauty
          </Text>
          <Text
            fontSize={{ base: "12px", md: "12px" }}
            textAlign={{ base: "center", md: "center" }}
            justifyContent={{ base: "center", md: "center" }}
            px={{ base: "24px", md: "34px" }}
            color="#000"
          >
            By using Virtual Beauty in the Ulta app, you acknowledge that you
            have read & agree to its terms and conditions (located at
            ulta.com/terms), including the collection, sharing, storage, & use
            of photos, videos, & facial geometry or landmarks. By tapping yes,
            you elect to share such information as set forth in the terms and
            conditions. By tapping no, you elect not to share such information,
            and you will be able to use hair try on only with models.
          </Text>
        </VStack>
        <VStack
          justifyContent="center"
          pb="20px"
          flexDirection="row"
          pt="0"
          gap={{ base: "14px", md: "20px" }}
          mt={{ base: "24px", md: "34px" }}
        >
          <Button
            fontSize={{ base: "12px", md: "15px" }}
            border="1px solid #000000"
            color={"white"}
            bg="black"
            _hover={{
              bg: "black",
            }}
            px={{ base: "24px", md: "24px" }}
            py={{ base: "10px", md: "15px" }}
            onClick={onClickYes}
          >
            Yes
          </Button>

          <Button
            ref={cancelRef}
            onClick={onClickNo}
            fontSize={{ base: "12px", md: "15px" }}
            border="1px solid #000000"
            color="#000"
            _hover={{ bg: "transparent" }}
            bg="transparent"
            px={{ base: "24px", md: "24px" }}
            py={{ base: "10px", md: "15px" }}
          >
            No
          </Button>
        </VStack>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default TermsAndConsAlertDialog;
